export const options = [
  {label: 'Física', value: "F" },
  {label: 'Jurídica', value: "J" }
];